<template>
    <span v-if="profile.role != 'User'">
        <span class="d-flex flex-row justify-start align-center">
            <p class="mr-3">Nombre de choix :</p>
            <v-text-field type="number" v-model="question.choicesAmount" @input="updateQuestionChoices(question)" dense />
        </span>
        <span>
            <p>Choix :</p>
            <v-text-field v-for="choice, i in question.choices" v-model="choice.text" type="text" :label="'Réponse n°' + (i+1)" outlined dense />
        </span>
        <span>
            <div>Correction :</div>
            <v-radio-group row v-model="question.correctAnswer" class="pt-0 mt-2">
                <v-radio v-for="choice in question.choices" :key="choice.text" :label="choice.text" :value="choice.text"></v-radio>
            </v-radio-group>
        </span>
    </span>

    <span v-else>
        <h4 v-text="question.text"></h4>
        <v-radio-group row v-model="question.response" class="pt-0 mt-2 d-flex flex-wrap" style="margin-bottom:-10px">
            <v-radio v-for="choice in question.choices" :key="choice.text" :label="choice.text" :value="choice.text" style="margin-bottom:-10px" class="mx-2" @click="$emit('edited')"></v-radio>
        </v-radio-group>
    </span>
</template>

<script>
export default {
    props: ["profile", "question"],
    data: () => ({
        response: {
            valide: false,
            errorMessage: ''
        }
    }),
    methods: {
        updateQuestionChoices(question){
            question.choices = []
            for (let i = 0; i < question.choicesAmount; i++) {
                question.choices.push({
                    text: null,
                })
            }
        },
        testIsValid(){
            // titre
            if(!this.question.text || this.question.text.trim() == ''){
                this.response.errorMessage = 'Veuillez renseigner un titre à toutes les questions.'
                return this.response
            }
            // au moins 2 choix
            if(this.question.choices.length < 2){
                this.response.errorMessage = 'Une des questions ne comporte pas assez de choix.'
                return this.response
            }
            // correction
            if(!this.question.correctAnswer){
                this.response.errorMessage = 'Veuillez renseigner une correction à toutes les questions.'
                return this.response
            }
            // choix
            for(let choice of this.question.choices){
                if(!choice.text || choice.text.trim() == ''){
                    this.response.errorMessage = 'Une des questions comporte un choix vide.'
                    return this.response
                }
            }
            this.response.valide = true
            return this.response
        }
    }
}
</script>